import { CaixaLotteryType, CaixaLottery } from "./types";

export const CAIXA_LOTTERIES: Record<CaixaLotteryType, CaixaLottery> = {
  "mega-sena": {
    id: "mega-sena",
    name: "Mega-Sena",
    description: "A loteria mais famosa do Brasil",
    icon: "🎯",
    minNumbers: 6,
    maxNumbers: 15,
    drawNumbers: 6,
    price: 6.00,
    drawDays: ["Terça", "Quinta", "Sábado"],
    numbersRange: "01 a 60",
    numbersToSelect: "6",
    minPrice: "R$ 6,00",
    closures: [
      {
        id: "mega-economico-3",
        name: "Econômico 3 Jogos",
        description: "7 dezenas em apenas 3 jogos",
        totalNumbers: 7,
        gamesGenerated: 3,
        guarantee: "Dupla se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "mega-economico-5",
        name: "Econômico 5 Jogos",
        description: "8 dezenas em apenas 5 jogos",
        totalNumbers: 8,
        gamesGenerated: 5,
        guarantee: "Dupla se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "mega-economico-7",
        name: "Econômico 7 Jogos",
        description: "9 dezenas em apenas 7 jogos",
        totalNumbers: 9,
        gamesGenerated: 7,
        guarantee: "Dupla se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "mega-economico-11",
        name: "Econômico 11 Jogos",
        description: "10 dezenas em apenas 11 jogos",
        totalNumbers: 10,
        gamesGenerated: 11,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "mega-economico-16",
        name: "Econômico 16 Jogos",
        description: "11 dezenas em apenas 16 jogos",
        totalNumbers: 11,
        gamesGenerated: 16,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "mega-economico-21",
        name: "Econômico 21 Jogos", 
        description: "12 dezenas em apenas 21 jogos",
        totalNumbers: 12,
        gamesGenerated: 21,
        guarantee: "Terno se acertar 4",
        isEconomic: false,
        hasFixedNumbers: true
      }
    ]
  },
  "quina": {
    id: "quina",
    name: "Quina",
    description: "Sorteios de segunda a sábado",
    icon: "🎲",
    minNumbers: 5,
    maxNumbers: 15,
    drawNumbers: 5,
    price: 3.00,
    drawDays: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    numbersRange: "01 a 80",
    numbersToSelect: "5",
    minPrice: "R$ 3,00",
    closures: [
      {
        id: "quina-economico-3",
        name: "Econômico 3 Jogos",
        description: "6 dezenas em apenas 3 jogos",
        totalNumbers: 6,
        gamesGenerated: 3,
        guarantee: "Dupla se acertar 3",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "quina-economico-5",
        name: "Econômico 5 Jogos",
        description: "7 dezenas em apenas 5 jogos",
        totalNumbers: 7,
        gamesGenerated: 5,
        guarantee: "Dupla se acertar 3",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "quina-economico-7",
        name: "Econômico 7 Jogos",
        description: "8 dezenas em apenas 7 jogos",
        totalNumbers: 8,
        gamesGenerated: 7,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "quina-economico-11",
        name: "Econômico 11 Jogos",
        description: "9 dezenas em apenas 11 jogos",
        totalNumbers: 9,
        gamesGenerated: 11,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "quina-economico-16",
        name: "Econômico 16 Jogos",
        description: "10 dezenas em apenas 16 jogos",
        totalNumbers: 10,
        gamesGenerated: 16,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "quina-economico-21",
        name: "Econômico 21 Jogos",
        description: "11 dezenas em apenas 21 jogos",
        totalNumbers: 11,
        gamesGenerated: 21,
        guarantee: "3 se acertar 4",
        isEconomic: false,
        hasFixedNumbers: true
      }
    ]
  },
  "lotofacil": {
    id: "lotofacil",
    name: "Lotofácil",
    description: "A loteria mais fácil de ganhar",
    icon: "🍀",
    minNumbers: 15,
    maxNumbers: 20,
    drawNumbers: 15,
    price: 3.50,
    drawDays: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    numbersRange: "01 a 25",
    numbersToSelect: "15",
    minPrice: "R$ 3,50",
    closures: [
      {
        id: "lotofacil-economico-3",
        name: "Econômico 3 Jogos",
        description: "16 dezenas em apenas 3 jogos",
        totalNumbers: 16,
        gamesGenerated: 3,
        guarantee: "11 pontos se acertar 13",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotofacil-economico-5",
        name: "Econômico 5 Jogos",
        description: "17 dezenas em apenas 5 jogos",
        totalNumbers: 17,
        gamesGenerated: 5,
        guarantee: "11 pontos se acertar 13",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotofacil-economico-7",
        name: "Econômico 7 Jogos",
        description: "17 dezenas em apenas 7 jogos",
        totalNumbers: 17,
        gamesGenerated: 7,
        guarantee: "12 pontos se acertar 14",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotofacil-economico-11",
        name: "Econômico 11 Jogos",
        description: "18 dezenas em apenas 11 jogos",
        totalNumbers: 18,
        gamesGenerated: 11,
        guarantee: "12 pontos se acertar 14",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotofacil-economico-16",
        name: "Econômico 16 Jogos",
        description: "19 dezenas em apenas 16 jogos",
        totalNumbers: 19,
        gamesGenerated: 16,
        guarantee: "12 pontos se acertar 14",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotofacil-economico-21",
        name: "Econômico 21 Jogos",
        description: "20 dezenas em apenas 21 jogos",
        totalNumbers: 20,
        gamesGenerated: 21,
        guarantee: "11 pontos garantidos",
        isEconomic: false,
        hasFixedNumbers: true
      }
    ]
  },
  "dupla-sena": {
    id: "dupla-sena",
    name: "Dupla Sena",
    description: "Duas chances de ganhar",
    icon: "🎰",
    minNumbers: 6,
    maxNumbers: 15,
    drawNumbers: 6,
    price: 3.00,
    drawDays: ["Terça", "Quinta", "Sábado"],
    numbersRange: "01 a 50",
    numbersToSelect: "6",
    minPrice: "R$ 3,00",
    closures: [
      {
        id: "dupla-economico-3",
        name: "Econômico 3 Jogos",
        description: "7 dezenas em apenas 3 jogos",
        totalNumbers: 7,
        gamesGenerated: 3,
        guarantee: "Dupla garantida",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dupla-economico-5",
        name: "Econômico 5 Jogos",
        description: "8 dezenas em apenas 5 jogos",
        totalNumbers: 8,
        gamesGenerated: 5,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dupla-economico-7",
        name: "Econômico 7 Jogos",
        description: "8 dezenas em apenas 7 jogos",
        totalNumbers: 8,
        gamesGenerated: 7,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dupla-economico-11",
        name: "Econômico 11 Jogos",
        description: "9 dezenas em apenas 11 jogos",
        totalNumbers: 9,
        gamesGenerated: 11,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dupla-economico-16",
        name: "Econômico 16 Jogos",
        description: "10 dezenas em apenas 16 jogos",
        totalNumbers: 10,
        gamesGenerated: 16,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dupla-economico-21",
        name: "Econômico 21 Jogos",
        description: "11 dezenas em apenas 21 jogos",
        totalNumbers: 11,
        gamesGenerated: 21,
        guarantee: "3 pontos garantidos",
        isEconomic: false,
        hasFixedNumbers: true
      }
    ]
  },
  "lotomania": {
    id: "lotomania",
    name: "Lotomania",
    description: "50 números escolhidos",
    icon: "🎪",
    minNumbers: 50,
    maxNumbers: 50,
    drawNumbers: 20,
    price: 3.00,
    drawDays: ["Terça", "Quinta", "Sábado"],
    numbersRange: "00 a 99",
    numbersToSelect: "50",
    minPrice: "R$ 3,00",
    closures: [
      {
        id: "lotomania-economico-3",
        name: "Sistema 3 Jogos",
        description: "3 jogos com estratégias diferentes",
        totalNumbers: 50,
        gamesGenerated: 3,
        guarantee: "Cobertura tripla",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotomania-economico-5",
        name: "Sistema 5 Jogos",
        description: "5 jogos com padrões variados",
        totalNumbers: 50,
        gamesGenerated: 5,
        guarantee: "Cobertura ampliada",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotomania-economico-7",
        name: "Sistema 7 Jogos",
        description: "7 jogos com estratégias avançadas",
        totalNumbers: 50,
        gamesGenerated: 7,
        guarantee: "Cobertura otimizada",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotomania-economico-11",
        name: "Sistema 11 Jogos",
        description: "11 jogos com padrões complexos",
        totalNumbers: 50,
        gamesGenerated: 11,
        guarantee: "Cobertura superior",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotomania-economico-16",
        name: "Sistema 16 Jogos",
        description: "16 jogos com máxima variação",
        totalNumbers: 50,
        gamesGenerated: 16,
        guarantee: "Cobertura premium",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "lotomania-economico-21",
        name: "Sistema 21 Jogos",
        description: "21 jogos com cobertura total",
        totalNumbers: 50,
        gamesGenerated: 21,
        guarantee: "Máxima cobertura",
        isEconomic: false,
        hasFixedNumbers: false
      }
    ]
  },
  "dia-de-sorte": {
    id: "dia-de-sorte",
    name: "Dia de Sorte",
    description: "Aposte no seu mês da sorte",
    icon: "📅",
    minNumbers: 7,
    maxNumbers: 15,
    drawNumbers: 7,
    price: 2.50,
    drawDays: ["Terça", "Quinta", "Sábado"],
    numbersRange: "01 a 31",
    numbersToSelect: "7",
    minPrice: "R$ 2,50",
    closures: [
      {
        id: "dia-economico-3",
        name: "Econômico 3 Jogos",
        description: "8 dezenas em apenas 3 jogos",
        totalNumbers: 8,
        gamesGenerated: 3,
        guarantee: "Dupla garantida",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dia-economico-5",
        name: "Econômico 5 Jogos",
        description: "9 dezenas em apenas 5 jogos",
        totalNumbers: 9,
        gamesGenerated: 5,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dia-economico-7",
        name: "Econômico 7 Jogos",
        description: "9 dezenas em apenas 7 jogos",
        totalNumbers: 9,
        gamesGenerated: 7,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dia-economico-11",
        name: "Econômico 11 Jogos",
        description: "10 dezenas em apenas 11 jogos",
        totalNumbers: 10,
        gamesGenerated: 11,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dia-economico-16",
        name: "Econômico 16 Jogos",
        description: "11 dezenas em apenas 16 jogos",
        totalNumbers: 11,
        gamesGenerated: 16,
        guarantee: "Terno se acertar 4",
        isEconomic: true,
        hasFixedNumbers: false
      },
      {
        id: "dia-economico-21",
        name: "Econômico 21 Jogos",
        description: "12 dezenas em apenas 21 jogos",
        totalNumbers: 12,
        gamesGenerated: 21,
        guarantee: "4 pontos garantidos",
        isEconomic: false,
        hasFixedNumbers: true
      }
    ]
  }
};